import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SmtpfComponent } from './pages/smtpf/smtpf.component';
import { ImprintComponent } from './pages/imprint/imprint.component';
import { ContactComponent } from './pages/contact/contact.component';

const routes: Routes = [
  { path: 'smtpf', component: SmtpfComponent },
  { path: 'imprint', component: ImprintComponent },
  { path: 'contact', component: ContactComponent },
  { path: '**', redirectTo: 'smtpf', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
